export const ANT_CALLBACKS = {
  INITIALIZED: 'initialized',
  PLAY_STARTED: 'play_started',
  PLAY_FINISHED: 'play_finished',
  CLOSED: 'closed',
  STREAM_INFORMATION: 'streamInformation',
  RESOLUTION_CHANGE_INFO: 'resolutionChangeInfo',
  ICE_CONNECTION_STATE_CHANGED: 'ice_connection_state_changed',
  DATA_RECEIVED: 'data_received',
  DATACHANNEL_NOT_OPEN: 'data_channel_not_open',
  NEW_TRACK_AVAILABLE: 'newTrackAvailable'
};
